import { DomainsTable } from './components/DomainsTable';

export function DomainsPage() {
  return (
    <main className="page-gutter min-w-0 flex-1 py-4 md:py-6">
      <DomainsTable />
    </main>
  );
}
